/**
 * Os dois caminhos pelos quais um arquivo entra num chat sem passar pelo seletor: o
 * gravador de áudio e a área de transferência.
 *
 * Mora aqui porque são quatro telas com o mesmo compositor — atendimento no painel,
 * atendimento no app, conversa interna no painel e conversa interna no app. Já esteve
 * copiado em duas delas, e a cópia é o que faz uma corrigir e a outra não.
 */
/** O gravador devolve um Blob; o caminho de anexo só trabalha com File. */
export function arquivoDeAudio(audio, mimeType) {
    const extensao = mimeType.includes('mp4') ? 'm4a' : mimeType.includes('ogg') ? 'ogg' : 'webm';
    return new File([audio], `audio-${Date.now()}.${extensao}`, { type: mimeType });
}
/**
 * A imagem que veio num Ctrl+V, se houver uma.
 *
 * Devolve `null` quando a colagem é texto — e aí quem chamou deixa o navegador colar
 * normalmente, sem prevenir o evento.
 *
 * O nome que o navegador dá a um print colado é sempre "image.png": datar ajuda quem for
 * procurar o arquivo depois, no atendimento ou no disco.
 */
export function imagemDaColagem(dados) {
    const itens = Array.from(dados?.items ?? []);
    const imagem = itens.find((i) => i.kind === 'file' && i.type.startsWith('image/'));
    const arquivo = imagem?.getAsFile();
    if (!arquivo)
        return null;
    const extensao = arquivo.type.split('/')[1]?.split('+')[0] ?? 'png';
    const carimbo = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '');
    return new File([arquivo], `print-${carimbo}.${extensao}`, { type: arquivo.type });
}
//# sourceMappingURL=anexos.js.map